"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryWriter = void 0;
const HexString_1 = require("./HexString");
const MAX_SCRIPT_SIZE = 0xffff;
class BinaryWriter {
    constructor() {
        this._stream = new Uint8Array(MAX_SCRIPT_SIZE);
        this._view = new DataView(this._stream.buffer);
        this._position = 0;
    }
    writeUint32(value) {
        this._view.setUint32(this._position, value, true);
        this._position += 4;
    }
    writeUint64(value) {
        let v = value;
        if (typeof value === "number") {
            v = BigInt(value);
        }
        this._view.setBigUint64(this._position, v, true);
        this._position += 8;
    }
    writeUInt160(value) {
        this.writeBytes(HexString_1.HexString.fromHex(value, true).toArrayBuffer());
    }
    writeUint16(value) {
        this._view.setUint16(this._position, value, true);
        this._position += 2;
    }
    writeBytes(value) {
        this._stream.set(value, this._position);
        this._position += value.length;
    }
    writeVarInt(value) {
        if (value < 0) {
            throw new Error("value too small");
        }
        else if (value < 0xfd) {
            this.writeBytes(new Uint8Array([value]));
        }
        else if (value <= 0xffff) {
            this.writeBytes(new Uint8Array([0xfd]));
            this.writeUint16(value);
        }
        else if (value <= 0xffffffff) {
            this.writeBytes(new Uint8Array([0xfe]));
            this.writeUint32(value);
        }
        else {
            this.writeBytes(new Uint8Array([0xff]));
            this.writeUint64(value);
        }
    }
    writeVarString(value) {
        const data = new TextEncoder().encode(value);
        this.writeVarInt(data.length);
        this._stream.set(data, this._position);
        this._position += data.length;
    }
    toArray() {
        return this._stream.slice(0, this._position);
    }
    toHex() {
        return HexString_1.HexString.fromArrayBuffer(this.toArray()).toString();
    }
    get length() {
        return this._position;
    }
}
exports.BinaryWriter = BinaryWriter;
